export const Table = {
  DEFAULT: {
    PAGE_INDEX: 0,
    PAGE_SIZE: 10,
    WIDTH_HACK: 150.55,
    MIN_WIDTH_HACK: 0,
  },
};
